module.exports = __webpack_public_path__ + "static/media/lecture.8ebc2373.svg";